import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {LocationManager} from '../../data/manager/location/location.manager';
import { DynamicYieldManager } from 'src/app/data/manager/dynamic-yield/dynamic-yield.manager';
import {OrderManager} from 'src/app/data/manager/order/order/order.manager';

@Injectable({
  providedIn: 'root',
})
export class LocationVm {
  constructor(
    private locationManager: LocationManager,
    private dyManager: DynamicYieldManager,
    private orderManager: OrderManager,
  ) {}

  getCities(params): Observable<any> {
    return this.locationManager.getCities(params);
  }

  getCountries(): Observable<any> {
    return this.locationManager.getCountries();
  }

  setCity(city, callNearbyStores) {
    this.locationManager.setCity(city, callNearbyStores);
  }

  getDeliveryTypeText(): Observable<any> {
    return this.locationManager.getDeliveryTypeText();
  }

  getCity(): Observable<any> {
    return this.locationManager.getCity();
  }

  getNameMainCity(): string {
    return this.locationManager.getNameMainCity();
  }

  changeContextLng(city){
    this.dyManager.setCityContextDY(city)
  }

  setNearbyStores() {
    return this.locationManager.setNearbyStores();
  }

  getDeliveryTypeTimeFromService(): void {
    this.orderManager.getDeliveryTypeTimeFromService()
      .subscribe({
        error: error => console.error('Error fetching delivery type time:', error),
      });
  }
}
